export default {
    methods: {
        downloadFile(url, label) {
            fetch(url, {
                responseType: 'blob',
            })
                .then((response) => response.blob())
                .then((blob) => {
                    const objectUrl = window.URL.createObjectURL(blob)

                    const link = document.createElement('a')
                    link.href = objectUrl
                    link.setAttribute('download', label)
                    document.body.appendChild(link)

                    link.click()
                })
        },
    },
}
